// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormRow-module__font-s-10___XnDPr {
  font-size: 10px !important;
}

.FormRow-module__font-s-12___Fab6o {
  font-size: 12px !important;
}

.FormRow-module__font-s-13___J_Qpo {
  font-size: 13px !important;
}

.FormRow-module__font-s-14____4Q9E {
  font-size: 14px !important;
}

.FormRow-module__font-s-15___le57b {
  font-size: 15px !important;
}

.FormRow-module__font-s-16___G1VXz {
  font-size: 16px !important;
}

.FormRow-module__font-s-18___svTIq {
  font-size: 18px !important;
}

.FormRow-module__font-s-20___TLrQx {
  font-size: 20px !important;
}

.FormRow-module__font-s-22___CH127 {
  font-size: 22px !important;
}

.FormRow-module__font-s-28___XMXYn {
  font-size: 28px !important;
}

.FormRow-module__font-w-400___AN4Qt {
  font-weight: 400 !important;
}

.FormRow-module__font-w-500___YcxSp {
  font-weight: 500 !important;
}

.FormRow-module__font-w-600___Tcvoa {
  font-weight: 600 !important;
}

.FormRow-module__font-w-700___ZGPTw {
  font-weight: 700 !important;
}

.FormRow-module__p-5___hdZjJ {
  padding: 5px !important;
}

.FormRow-module__p-12____WDHa {
  padding: 12px !important;
}

.FormRow-module__p-16___bY2XN {
  padding: 16px !important;
}

.FormRow-module__p-30___SRawv {
  padding: 30px !important;
}

.FormRow-module__p-b-0___RLsAN {
  padding-bottom: 0 !important;
}

.FormRow-module__p-b-5___RYGnJ {
  padding-bottom: 5px !important;
}

.FormRow-module__p-b-10___X6_O3 {
  padding-bottom: 10px !important;
}

.FormRow-module__p-b-12___QrU32 {
  padding-bottom: 12px !important;
}

.FormRow-module__p-b-16___pU7q9 {
  padding-bottom: 16px !important;
}

.FormRow-module__p-b-18___ChNtg {
  padding-bottom: 18px !important;
}

.FormRow-module__p-b-20___LKmuW {
  padding-bottom: 20px !important;
}

.FormRow-module__p-b-25___oMz0G {
  padding-bottom: 25px !important;
}

.FormRow-module__p-b-30___eZ3in {
  padding-bottom: 30px !important;
}

.FormRow-module__p-b-50___kQU0r {
  padding-bottom: 50px !important;
}

.FormRow-module__p-t-0___Ikw4e {
  padding-top: 0 !important;
}

.FormRow-module__p-t-12___hKNzV {
  padding-top: 12px !important;
}

.FormRow-module__p-t-16___hS_Hj {
  padding-top: 16px !important;
}

.FormRow-module__p-t-18___u115_ {
  padding-top: 18px !important;
}

.FormRow-module__p-t-20____obZo {
  padding-top: 20px !important;
}

.FormRow-module__p-t-30___X2J_w {
  padding-top: 30px !important;
}

.FormRow-module__p-t-40___Mwyjo {
  padding-top: 40px !important;
}

.FormRow-module__p-t-50___rp_YW {
  padding-top: 50px !important;
}

.FormRow-module__p-l-20___esAQW {
  padding-left: 20px !important;
}

.FormRow-module__p-l-30___OUwn7 {
  padding-left: 30px !important;
}

.FormRow-module__p-l-40___S8TiK {
  padding-left: 40px !important;
}

.FormRow-module__p-r-16___Z4mNh {
  padding-right: 16px !important;
}

.FormRow-module__p-r-20___OFYOF {
  padding-right: 20px !important;
}

.FormRow-module__p-r-30___pHE1J {
  padding-right: 30px !important;
}

.FormRow-module__p-r-50___CIozS {
  padding-right: 50px !important;
}

.FormRow-module__p-r-60___SA5pI {
  padding-right: 60px !important;
}

.FormRow-module__m-b-1___KGuAL {
  margin-bottom: 1px !important;
}

.FormRow-module__m-b-2___V2bb9 {
  margin-bottom: 2px !important;
}

.FormRow-module__m-b-6___TZ9Rt {
  margin-bottom: 6px !important;
}

.FormRow-module__m-b-8___CJyQ0 {
  margin-bottom: 8px !important;
}

.FormRow-module__m-b-10___cuXh_ {
  margin-bottom: 10px !important;
}

.FormRow-module__m-b-14___EXKDy {
  margin-bottom: 14px !important;
}

.FormRow-module__m-b-16___vD9GH {
  margin-bottom: 16px !important;
}

.FormRow-module__m-b-20___qr3pM {
  margin-bottom: 20px !important;
}

.FormRow-module__m-b-22___zuAXQ {
  margin-bottom: 22px !important;
}

.FormRow-module__m-b-24___DxC01 {
  margin-bottom: 24px !important;
}

.FormRow-module__m-b-30___Enxrp {
  margin-bottom: 30px !important;
}

.FormRow-module__m-b-32___lw728 {
  margin-bottom: 32px !important;
}

.FormRow-module__m-b-40___sE7bS {
  margin-bottom: 40px !important;
}

.FormRow-module__m-t-2___CyMko {
  margin-top: 2px !important;
}

.FormRow-module__m-t-3___RgCBK {
  margin-top: 3px !important;
}

.FormRow-module__m-t-4___uZJPm {
  margin-top: 4px !important;
}

.FormRow-module__m-t-5___Bzd93 {
  margin-top: 5px !important;
}

.FormRow-module__m-t-8___UzhYP {
  margin-top: 8px !important;
}

.FormRow-module__m-t-10___wCED1 {
  margin-top: 10px !important;
}

.FormRow-module__m-t-15___qDy5j {
  margin-top: 15px !important;
}

.FormRow-module__m-t-16___OA8X9 {
  margin-top: 16px !important;
}

.FormRow-module__m-t-20___ZyelL {
  margin-top: 20px !important;
}

.FormRow-module__m-t-22___FyfXi {
  margin-top: 22px !important;
}

.FormRow-module__m-t-30___Q50H7 {
  margin-top: 30px !important;
}

.FormRow-module__m-t-32____Tbmd {
  margin-top: 32px !important;
}

.FormRow-module__m-l-auto___vNGXy {
  margin-left: auto !important;
}

.FormRow-module__m-l-4___b03SN {
  margin-left: 4px !important;
}

.FormRow-module__m-l-5___TexJ_ {
  margin-left: 5px !important;
}

.FormRow-module__m-l-6___vKc3B {
  margin-left: 6px !important;
}

.FormRow-module__m-l-8___EpZDk {
  margin-left: 8px !important;
}

.FormRow-module__m-l-10___bFan3 {
  margin-left: 10px !important;
}

.FormRow-module__m-l-16___qMtG5 {
  margin-left: 16px !important;
}

.FormRow-module__m-l-20___CJG1r {
  margin-left: 20px !important;
}

.FormRow-module__m-l-24___HUzxR {
  margin-left: 24px !important;
}

.FormRow-module__m-l-30___M1Tuz {
  margin-left: 30px !important;
}

.FormRow-module__m-l-35___p6azD {
  margin-left: 35px !important;
}

.FormRow-module__m-l-40___S6ZDz {
  margin-left: 40px !important;
}

.FormRow-module__m-r-8___igpTl {
  margin-right: 8px !important;
}

.FormRow-module__m-r-10___v6E8p {
  margin-right: 10px !important;
}

.FormRow-module__m-r-16___VNW_w {
  margin-right: 16px !important;
}

.FormRow-module__m-r-20___BzY7E {
  margin-right: 20px !important;
}

.FormRow-module__m-r-24___XMsZK {
  margin-right: 24px !important;
}

.FormRow-module__m-r-30___pr3By {
  margin-right: 30px !important;
}

.FormRow-module__m-r-40___fwTrY {
  margin-right: 40px !important;
}

.FormRow-module__border-r-3___ZnrS8 {
  border-radius: 3px !important;
}

.FormRow-module__border-r-4___A4KQU {
  border-radius: 4px !important;
}

.FormRow-module__border-r-6___R4mjS {
  border-radius: 6px !important;
}

.FormRow-module__border-r-10___Hfkx3 {
  border-radius: 10px !important;
}

.FormRow-module__border-r-12___m1wvD {
  border-radius: 12px !important;
}

.FormRow-module__border-r-16___T9oqN {
  border-radius: 16px !important;
}

.FormRow-module__border-r-50___JElnR {
  border-radius: 50% !important;
}

.FormRow-module__primary-border___DJdd2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FormRow-module__primary-border-b___hm7to {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FormRow-module__primary-border-t___igucB {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FormRow-module__primary-border-l___EYI4w {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FormRow-module__primary-border-r___NDEhK {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FormRow-module__secondary-border___fUTtJ {
  border: 1px solid #637768;
}

.FormRow-module__secondary-border-b___epPVa {
  border-bottom: 1px solid #637768;
}

.FormRow-module__secondary-border-t___FQMes {
  border-top: 1px solid #637768;
}

.FormRow-module__secondary-border-l___XTDel {
  border-left: 1px solid #637768;
}

.FormRow-module__secondary-border-r___vdUsT {
  border-right: 1px solid #637768;
}

.FormRow-module__gap-0___wfYN4 {
  gap: 0 !important;
}

.FormRow-module__gap-2___l8xdE {
  gap: 2px !important;
}

.FormRow-module__gap-4___aO2jC {
  gap: 4px !important;
}

.FormRow-module__gap-5___r0rXf {
  gap: 5px !important;
}

.FormRow-module__gap-6___txoRe {
  gap: 6px !important;
}

.FormRow-module__gap-8___bMqVB {
  gap: 8px !important;
}

.FormRow-module__gap-10___tk8BB {
  gap: 10px !important;
}

.FormRow-module__gap-12___J335P {
  gap: 12px !important;
}

.FormRow-module__gap-14___GNP7C {
  gap: 14px !important;
}

.FormRow-module__gap-16___I62My {
  gap: 16px !important;
}

.FormRow-module__gap-18___hOUSr {
  gap: 18px !important;
}

.FormRow-module__gap-20___ijrbr {
  gap: 20px !important;
}

.FormRow-module__gap-24___h__0Q {
  gap: 24px !important;
}

.FormRow-module__gap-26___ZS77d {
  gap: 26px !important;
}

.FormRow-module__gap-30___hR01q {
  gap: 30px !important;
}

.FormRow-module__gap-32___yZ_L6 {
  gap: 32px !important;
}

.FormRow-module__gap-40___sdu3Z {
  gap: 40px !important;
}

.FormRow-module__gap-50___lreOp {
  gap: 50px !important;
}

.FormRow-module__flex-1___eSmea {
  flex: 1;
}

.FormRow-module__flex-none___cZyvR {
  flex: none !important;
}

.FormRow-module__flex-column___PEfg2 {
  display: flex;
  flex-direction: column !important;
}

.FormRow-module__flex-row___b0Jke {
  display: flex;
  flex-direction: row !important;
}

.FormRow-module__vertically-centered___Di17Z {
  display: flex;
  align-items: center !important;
}

.FormRow-module__horizontally-centered___hSMLe {
  display: flex;
  justify-content: center !important;
}

.FormRow-module__horizontally-end___ugyde {
  display: flex;
  justify-content: end !important;
}

.FormRow-module__vertically-start___zCObV {
  display: flex;
  align-items: start !important;
}

.FormRow-module__space-between___ou_FJ {
  display: flex;
  justify-content: space-between !important;
}

.FormRow-module__flex-wrap___McUoZ {
  flex-wrap: wrap !important;
}

.FormRow-module__height-100___XgTK0 {
  height: 100%;
}

.FormRow-module__width-50___TGSos {
  width: 50% !important;
}

.FormRow-module__width-100___J5o43 {
  width: 100%;
}

.FormRow-module__cursor-pointer___oL9WG {
  cursor: pointer;
}

.FormRow-module__cursor-not-allowed___eaXV2 {
  cursor: not-allowed !important;
}

.FormRow-module__absolute-centered___joCxq {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FormRow-module__absolute___FAiC_ {
  position: absolute;
}

.FormRow-module__relative___RFlOx {
  position: relative;
}

.FormRow-module__fixed___hsf4b {
  position: fixed;
}

.FormRow-module__visible____SKcz {
  opacity: 1;
}

.FormRow-module__invisible___1Rw23 {
  opacity: 0;
}

.FormRow-module__col-90___IeTnb {
  width: 90% !important;
}

.FormRow-module__col-auto___ZCBuG {
  width: auto !important;
}

.FormRow-module__medical-tabs___s7KJL {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FormRow-module__medical-table-new___M3x01 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormRow-module__medical-table-new___M3x01:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormRow-module__medical-table-new___M3x01::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormRow-module__medical-table-new___M3x01::-webkit-scrollbar-track {
  display: none;
}
.FormRow-module__medical-table-new___M3x01.FormRow-module__no-pagination___jA2mW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FormRow-module__medical-table-new___M3x01.FormRow-module__no-pagination___jA2mW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FormRow-module__medical-table-new___M3x01.FormRow-module__no-pagination___jA2mW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FormRow-module__medical-table-new___M3x01.FormRow-module__no-pagination___jA2mW::-webkit-scrollbar-track {
  display: none;
}

.FormRow-module__medical-table-empty___I5o3C {
  padding: 14px 40px !important;
}

.FormRow-module__icon-btn___nsl96 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FormRow-module__search-icon___BUmy_ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FormRow-module__disable-select___V4GAt {
  user-select: none;
}

.FormRow-module__break-word___PN2bE {
  word-break: break-word;
}

.FormRow-module__popup-clear-btn___wkqW7 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FormRow-module__scroll-m-b-20___sUkZv {
  scroll-margin-bottom: 20px;
}

.FormRow-module__row___SM8Ix {
  padding: 19px 30px 2px 0;
  justify-content: space-between;
}
.FormRow-module__row___SM8Ix:not(:last-child) {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}
.FormRow-module__row___SM8Ix .FormRow-module__title___q1Ji3 {
  color: #375844;
  display: inline-block;
}
.FormRow-module__row___SM8Ix .FormRow-module__select___kelx4 {
  width: 205px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/CGMOrderPopup/FormRow/FormRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,wBAAA;EACA,8BAAA;AA8pBF;AA5pBE;EACE,8CAAA;AA8pBJ;AA3pBE;EACE,cAAA;EACA,qBAAA;AA6pBJ;AA1pBE;EACE,YAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.row {\n  padding: 19px 30px 2px 0;\n  justify-content: space-between;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n  }\n\n  .title {\n    color: get-color(greenNew, dark);\n    display: inline-block;\n  }\n\n  .select {\n    width: 205px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FormRow-module__font-s-10___XnDPr`,
	"fontS12": `FormRow-module__font-s-12___Fab6o`,
	"fontS13": `FormRow-module__font-s-13___J_Qpo`,
	"fontS14": `FormRow-module__font-s-14____4Q9E`,
	"fontS15": `FormRow-module__font-s-15___le57b`,
	"fontS16": `FormRow-module__font-s-16___G1VXz`,
	"fontS18": `FormRow-module__font-s-18___svTIq`,
	"fontS20": `FormRow-module__font-s-20___TLrQx`,
	"fontS22": `FormRow-module__font-s-22___CH127`,
	"fontS28": `FormRow-module__font-s-28___XMXYn`,
	"fontW400": `FormRow-module__font-w-400___AN4Qt`,
	"fontW500": `FormRow-module__font-w-500___YcxSp`,
	"fontW600": `FormRow-module__font-w-600___Tcvoa`,
	"fontW700": `FormRow-module__font-w-700___ZGPTw`,
	"p5": `FormRow-module__p-5___hdZjJ`,
	"p12": `FormRow-module__p-12____WDHa`,
	"p16": `FormRow-module__p-16___bY2XN`,
	"p30": `FormRow-module__p-30___SRawv`,
	"pB0": `FormRow-module__p-b-0___RLsAN`,
	"pB5": `FormRow-module__p-b-5___RYGnJ`,
	"pB10": `FormRow-module__p-b-10___X6_O3`,
	"pB12": `FormRow-module__p-b-12___QrU32`,
	"pB16": `FormRow-module__p-b-16___pU7q9`,
	"pB18": `FormRow-module__p-b-18___ChNtg`,
	"pB20": `FormRow-module__p-b-20___LKmuW`,
	"pB25": `FormRow-module__p-b-25___oMz0G`,
	"pB30": `FormRow-module__p-b-30___eZ3in`,
	"pB50": `FormRow-module__p-b-50___kQU0r`,
	"pT0": `FormRow-module__p-t-0___Ikw4e`,
	"pT12": `FormRow-module__p-t-12___hKNzV`,
	"pT16": `FormRow-module__p-t-16___hS_Hj`,
	"pT18": `FormRow-module__p-t-18___u115_`,
	"pT20": `FormRow-module__p-t-20____obZo`,
	"pT30": `FormRow-module__p-t-30___X2J_w`,
	"pT40": `FormRow-module__p-t-40___Mwyjo`,
	"pT50": `FormRow-module__p-t-50___rp_YW`,
	"pL20": `FormRow-module__p-l-20___esAQW`,
	"pL30": `FormRow-module__p-l-30___OUwn7`,
	"pL40": `FormRow-module__p-l-40___S8TiK`,
	"pR16": `FormRow-module__p-r-16___Z4mNh`,
	"pR20": `FormRow-module__p-r-20___OFYOF`,
	"pR30": `FormRow-module__p-r-30___pHE1J`,
	"pR50": `FormRow-module__p-r-50___CIozS`,
	"pR60": `FormRow-module__p-r-60___SA5pI`,
	"mB1": `FormRow-module__m-b-1___KGuAL`,
	"mB2": `FormRow-module__m-b-2___V2bb9`,
	"mB6": `FormRow-module__m-b-6___TZ9Rt`,
	"mB8": `FormRow-module__m-b-8___CJyQ0`,
	"mB10": `FormRow-module__m-b-10___cuXh_`,
	"mB14": `FormRow-module__m-b-14___EXKDy`,
	"mB16": `FormRow-module__m-b-16___vD9GH`,
	"mB20": `FormRow-module__m-b-20___qr3pM`,
	"mB22": `FormRow-module__m-b-22___zuAXQ`,
	"mB24": `FormRow-module__m-b-24___DxC01`,
	"mB30": `FormRow-module__m-b-30___Enxrp`,
	"mB32": `FormRow-module__m-b-32___lw728`,
	"mB40": `FormRow-module__m-b-40___sE7bS`,
	"mT2": `FormRow-module__m-t-2___CyMko`,
	"mT3": `FormRow-module__m-t-3___RgCBK`,
	"mT4": `FormRow-module__m-t-4___uZJPm`,
	"mT5": `FormRow-module__m-t-5___Bzd93`,
	"mT8": `FormRow-module__m-t-8___UzhYP`,
	"mT10": `FormRow-module__m-t-10___wCED1`,
	"mT15": `FormRow-module__m-t-15___qDy5j`,
	"mT16": `FormRow-module__m-t-16___OA8X9`,
	"mT20": `FormRow-module__m-t-20___ZyelL`,
	"mT22": `FormRow-module__m-t-22___FyfXi`,
	"mT30": `FormRow-module__m-t-30___Q50H7`,
	"mT32": `FormRow-module__m-t-32____Tbmd`,
	"mLAuto": `FormRow-module__m-l-auto___vNGXy`,
	"mL4": `FormRow-module__m-l-4___b03SN`,
	"mL5": `FormRow-module__m-l-5___TexJ_`,
	"mL6": `FormRow-module__m-l-6___vKc3B`,
	"mL8": `FormRow-module__m-l-8___EpZDk`,
	"mL10": `FormRow-module__m-l-10___bFan3`,
	"mL16": `FormRow-module__m-l-16___qMtG5`,
	"mL20": `FormRow-module__m-l-20___CJG1r`,
	"mL24": `FormRow-module__m-l-24___HUzxR`,
	"mL30": `FormRow-module__m-l-30___M1Tuz`,
	"mL35": `FormRow-module__m-l-35___p6azD`,
	"mL40": `FormRow-module__m-l-40___S6ZDz`,
	"mR8": `FormRow-module__m-r-8___igpTl`,
	"mR10": `FormRow-module__m-r-10___v6E8p`,
	"mR16": `FormRow-module__m-r-16___VNW_w`,
	"mR20": `FormRow-module__m-r-20___BzY7E`,
	"mR24": `FormRow-module__m-r-24___XMsZK`,
	"mR30": `FormRow-module__m-r-30___pr3By`,
	"mR40": `FormRow-module__m-r-40___fwTrY`,
	"borderR3": `FormRow-module__border-r-3___ZnrS8`,
	"borderR4": `FormRow-module__border-r-4___A4KQU`,
	"borderR6": `FormRow-module__border-r-6___R4mjS`,
	"borderR10": `FormRow-module__border-r-10___Hfkx3`,
	"borderR12": `FormRow-module__border-r-12___m1wvD`,
	"borderR16": `FormRow-module__border-r-16___T9oqN`,
	"borderR50": `FormRow-module__border-r-50___JElnR`,
	"primaryBorder": `FormRow-module__primary-border___DJdd2`,
	"primaryBorderB": `FormRow-module__primary-border-b___hm7to`,
	"primaryBorderT": `FormRow-module__primary-border-t___igucB`,
	"primaryBorderL": `FormRow-module__primary-border-l___EYI4w`,
	"primaryBorderR": `FormRow-module__primary-border-r___NDEhK`,
	"secondaryBorder": `FormRow-module__secondary-border___fUTtJ`,
	"secondaryBorderB": `FormRow-module__secondary-border-b___epPVa`,
	"secondaryBorderT": `FormRow-module__secondary-border-t___FQMes`,
	"secondaryBorderL": `FormRow-module__secondary-border-l___XTDel`,
	"secondaryBorderR": `FormRow-module__secondary-border-r___vdUsT`,
	"gap0": `FormRow-module__gap-0___wfYN4`,
	"gap2": `FormRow-module__gap-2___l8xdE`,
	"gap4": `FormRow-module__gap-4___aO2jC`,
	"gap5": `FormRow-module__gap-5___r0rXf`,
	"gap6": `FormRow-module__gap-6___txoRe`,
	"gap8": `FormRow-module__gap-8___bMqVB`,
	"gap10": `FormRow-module__gap-10___tk8BB`,
	"gap12": `FormRow-module__gap-12___J335P`,
	"gap14": `FormRow-module__gap-14___GNP7C`,
	"gap16": `FormRow-module__gap-16___I62My`,
	"gap18": `FormRow-module__gap-18___hOUSr`,
	"gap20": `FormRow-module__gap-20___ijrbr`,
	"gap24": `FormRow-module__gap-24___h__0Q`,
	"gap26": `FormRow-module__gap-26___ZS77d`,
	"gap30": `FormRow-module__gap-30___hR01q`,
	"gap32": `FormRow-module__gap-32___yZ_L6`,
	"gap40": `FormRow-module__gap-40___sdu3Z`,
	"gap50": `FormRow-module__gap-50___lreOp`,
	"flex1": `FormRow-module__flex-1___eSmea`,
	"flexNone": `FormRow-module__flex-none___cZyvR`,
	"flexColumn": `FormRow-module__flex-column___PEfg2`,
	"flexRow": `FormRow-module__flex-row___b0Jke`,
	"verticallyCentered": `FormRow-module__vertically-centered___Di17Z`,
	"horizontallyCentered": `FormRow-module__horizontally-centered___hSMLe`,
	"horizontallyEnd": `FormRow-module__horizontally-end___ugyde`,
	"verticallyStart": `FormRow-module__vertically-start___zCObV`,
	"spaceBetween": `FormRow-module__space-between___ou_FJ`,
	"flexWrap": `FormRow-module__flex-wrap___McUoZ`,
	"height100": `FormRow-module__height-100___XgTK0`,
	"width50": `FormRow-module__width-50___TGSos`,
	"width100": `FormRow-module__width-100___J5o43`,
	"cursorPointer": `FormRow-module__cursor-pointer___oL9WG`,
	"cursorNotAllowed": `FormRow-module__cursor-not-allowed___eaXV2`,
	"absoluteCentered": `FormRow-module__absolute-centered___joCxq`,
	"absolute": `FormRow-module__absolute___FAiC_`,
	"relative": `FormRow-module__relative___RFlOx`,
	"fixed": `FormRow-module__fixed___hsf4b`,
	"visible": `FormRow-module__visible____SKcz`,
	"invisible": `FormRow-module__invisible___1Rw23`,
	"col90": `FormRow-module__col-90___IeTnb`,
	"colAuto": `FormRow-module__col-auto___ZCBuG`,
	"medicalTabs": `FormRow-module__medical-tabs___s7KJL`,
	"medicalTableNew": `FormRow-module__medical-table-new___M3x01`,
	"noPagination": `FormRow-module__no-pagination___jA2mW`,
	"medicalTableEmpty": `FormRow-module__medical-table-empty___I5o3C`,
	"iconBtn": `FormRow-module__icon-btn___nsl96`,
	"searchIcon": `FormRow-module__search-icon___BUmy_`,
	"disableSelect": `FormRow-module__disable-select___V4GAt`,
	"breakWord": `FormRow-module__break-word___PN2bE`,
	"popupClearBtn": `FormRow-module__popup-clear-btn___wkqW7`,
	"scrollMB20": `FormRow-module__scroll-m-b-20___sUkZv`,
	"row": `FormRow-module__row___SM8Ix`,
	"title": `FormRow-module__title___q1Ji3`,
	"select": `FormRow-module__select___kelx4`
};
module.exports = ___CSS_LOADER_EXPORT___;
